<template>
	<ConsoleEventArg
		renderAs="ArgObject"
		:value="asObject"
		:serialized="serialized"
		:constructorName="constructorName"
		icon="vue"
	/>
</template>

<script>
export default {
	name: 'ArgVue',
	props: {value: Object, serialized: Object},
	computed: {
		constructorName() {
			return this.value.data?.name || this.value.data?.componentTag || 'Vue'
		},
		asObject() {
			return this.value.data
		},
	},
}
</script>
